angular.module('picmonic-common').factory('WebinarResource', [
  '$resource',
  function ($resource) {
    return $resource('/api/v3/webinars/:webinar_id/:resource_type', {
      webinar_id: '@webinar_id',
      resource_type: '@resource_type',
    });
  },
]);
